
import { DATA_MODIFICATIONS } from '../../reducers/data';

export default function getModificationById(moId) {
    return DATA_MODIFICATIONS.reduce((previous, current) => {
        return (current.id === moId)
            ? current
            : previous;
    }, null);
}
